module.exports = __webpack_public_path__ + "img/gzdpyl.0a1b736d.png";